import axios from '@/utils/request'

export default {
	// 2020-11-28
	insertBatch(params) {
		return axios.post('/sales-target-items/insert-batch', params);
	},
	// 2020-11-28
	updateBatch(params) {
		return axios.post('/sales-target-items/update-batch', params);
	},
	// 2020-12-30
	delete(id) {
		return axios.delete('/sales-target-items/' + id);
	},
	// 2020-11-28
	findBySalesTargetId(params) {
		return axios.get('/sales-target-items/find-by-sales-target-id', params);
	}
}

